import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {

    getExtrato(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios.get('conta/extrato', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => { reject(error) })
      })
    },

    getExtratoResumo() {
      return axios.get('conta/extrato-resumo')
    },
  },
}
